import classNames from "classnames"
import React, { useEffect } from "react"
import CardItem from "../components/Card/CardItem"
import HomeCardContent from "../constants/HomeCardContent.json"
import { Col, Row, Card, CardBody } from "reactstrap"
import { Link } from "react-router-dom"
import userIcon from "../assets/images/services-icon/user.png"
import partnerIcon from "../assets/images/services-icon/partner.png"
import adminIcon from "../assets/images/services-icon/admin.png"
import jobIcon from "../assets/images/services-icon/job.png"
import API from "../api/api"
import { useState } from "react"
import { db } from "../helpers/firebase_helper"

const HomeCardContainer = () => {
  const { content, xlSize, mdSize } = HomeCardContent
  const [usersCount, setUsersCount] = useState([])
  const [jobsCount, setJobsCount] = useState()

  // useEffect(async () => {
  //   try {
  //     const response = await API.getAnalyticsCount()
  //     setUsersCount(response.data.data)
  //   } catch (e) {
  //     console.log(e)
  //   }

  //   try {
  //     const response = await API.getJobsCount()
  //     setJobsCount(response.data.data.length)
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }, [])

  /*********************************************************************
   * FIREBASE INTEGRATION
   ********************************************************************/
  const getUsersCount = async () => {
    const snapshot = await db.collection("analytics").doc('userCounts').get()
    console.log("Users count data", snapshot.data())
    setUsersCount(snapshot.data())
  }

  useEffect(() => {
    getUsersCount()
  }, [])  

  return (
    <Row>
      <Col xl={3} md={6}>
        <Link to="/users">
          <Card className="mini-stat bg-success text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={userIcon} alt="" />
                </div>
                <h5 className="font-size-15 text-uppercase mt-0 text-white-50">
                  NUMBER OF USERS
                </h5>
                <h4 className="fw-medium font-size-24">
                  {usersCount.users}
                  {/* <i className="mdi mdi-arrow-up text-success ms-2"></i> */}
                </h4>
              </div>
              <div className="pt-2">
                <div className="float-end">
                  <Link to="#" className="text-white-50">
                    <i className="mdi mdi-arrow-right h5"></i>
                  </Link>
                </div>
                <p className="text-white-50 mb-0 mt-1"></p>
              </div>
            </CardBody>
          </Card>
        </Link>
      </Col>
      <Col xl={3} md={6}>
        <Link to="/seviceproviders">
          <Card className="mini-stat bg-success text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={partnerIcon} alt="" />
                </div>
                <h5 className="font-size-15 text-uppercase mt-0 text-white-50">
                  NUMBER OF PARTNERS
                </h5>
                <h4 className="fw-medium font-size-24">
                  {usersCount.serviceProiver}
                  {/* <i className="mdi mdi-arrow-up text-success ms-2"></i> */}
                </h4>
              </div>
              <div className="pt-2">
                <div className="float-end">
                  <Link to="#" className="text-white-50">
                    <i className="mdi mdi-arrow-right h5"></i>
                  </Link>
                </div>
                <p className="text-white-50 mb-0 mt-1"></p>
              </div>
            </CardBody>
          </Card>
        </Link>
      </Col>
      <Col xl={3} md={6}>
        <Link to="/admins">
          <Card className="mini-stat bg-success text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={adminIcon} alt="" />
                </div>
                <h5 className="font-size-15 text-uppercase mt-0 text-white-50">
                  NUMBER OF ADMINS
                </h5>
                <h4 className="fw-medium font-size-24">
                  {usersCount.admins}
                  {/* <i className="mdi mdi-arrow-up text-success ms-2"></i> */}
                </h4>
              </div>
              <div className="pt-2">
                <div className="float-end">
                  <Link to="#" className="text-white-50">
                    <i className="mdi mdi-arrow-right h5"></i>
                  </Link>
                </div>
                <p className="text-white-50 mb-0 mt-1"></p>
              </div>
            </CardBody>
          </Card>
        </Link>
      </Col>
      <Col xl={3} md={6}>
        <Link to="/orders">
          <Card className="mini-stat bg-success text-white">
            <CardBody>
              <div className="mb-4">
                <div className="float-start mini-stat-img me-4">
                  <img src={jobIcon} alt="" />
                </div>
                <h5 className="font-size-15 text-uppercase mt-0 text-white-50">
                  NUMBER OF JOBS
                </h5>
                <h4 className="fw-medium font-size-24">
                  {jobsCount}
                  {/* <i className="mdi mdi-arrow-up text-success ms-2"></i> */}
                </h4>
              </div>
              <div className="pt-2">
                <div className="float-end">
                  <Link to="#" className="text-white-50">
                    <i className="mdi mdi-arrow-right h5"></i>
                  </Link>
                </div>
                <p className="text-white-50 mb-0 mt-1"></p>
              </div>
            </CardBody>
          </Card>
        </Link>
      </Col>
    </Row>
  )
}

export default HomeCardContainer
